import { type FC } from "react";

import { BenefitIcon } from "../BenefitIcon/BenefitIcon";

import styles from "./CertProBenefitsList.module.scss";
import { FormattedMessage } from "react-intl";
import { FormattedHTMLMessage } from "~/nvent-web/components/FormattedHTMLMessage/FormattedHTMLMessage";
import { Promotion as PromotionComponent } from "../Promotion/Promotion";
import type { Promotion } from "~/nvent-web-admin/types/Promotion";

interface CertProBenefitsListProps {
  promotions: Promotion[];
  logoUrl: string;
  contactEmail: string;
}

export const CertProBenefitsList: FC<CertProBenefitsListProps> = (props) => {
  return (
    <section className={styles.container}>
      <div className={styles.titleRow}>
        <BenefitIcon
          icon="TwentyYears"
          borderRadius="sm"
          className={styles.titleIcon}
        />

        <h3 className={styles.title}>
          <FormattedMessage id="certifiedPage.proBenefits.title" />
        </h3>
      </div>

      <p className={styles.lead}>
        <FormattedMessage id="certifiedPage.proBenefits.lead" />
      </p>

      <ul className={styles.cards}>
        <li className={styles.card}>
          <BenefitIcon
            icon="Certifiacte"
            borderRadius="sm"
            className={styles.cardIcon}
          />

          <p className={styles.cardContent}>
            <FormattedHTMLMessage
              id="certifiedPage.proBenefits.download"
              Element="span"
              values={{
                href: props.logoUrl,
              }}
            />
          </p>
        </li>

        <li className={styles.card}>
          <BenefitIcon
            icon="Website"
            borderRadius="sm"
            className={styles.cardIcon}
          />

          <p className={styles.cardContent}>
            <FormattedHTMLMessage
              id="certifiedPage.proBenefits.installer"
              Element="span"
              values={{
                contactEmail: props.contactEmail,
              }}
            />
          </p>
        </li>

        <li className={styles.card}>
          <BenefitIcon
            icon="News"
            borderRadius="sm"
            className={styles.cardIcon}
          />

          <div className={styles.cardContent}>
            <p className={styles.cardHeading}>
              <FormattedMessage id="certifiedPage.proBenefits.news" />
            </p>

            {props.promotions.length === 0 ? (
              <FormattedMessage id="certifiedPage.certified.activePromotions.empty" />
            ) : (
              props.promotions.map((promotion) => (
                <PromotionComponent promotion={promotion} key={promotion.id} />
              ))
            )}
          </div>
        </li>

        <li className={styles.card}>
          <BenefitIcon
            icon="TwentyYears"
            borderRadius="sm"
            className={styles.cardIcon}
          />

          <div className={styles.cardContent}>
            <p className={styles.cardHeading}>
              <FormattedMessage id="certifiedPage.proBenefits.nutshell.title" />
            </p>
            <FormattedHTMLMessage
              id="certifiedPage.proBenefits.nutshell.list"
              Element="ul"
            />
          </div>
        </li>
      </ul>
    </section>
  );
};
